<template>
  <div>
    <Teleport v-if="showTeleport" to=".header__left-menu">
      <ul class="b-booking-header">
        <li
          v-for="index in 6"
          :key="index"
          :class="[activeTab(index), isDone(index) ? 'is-done' : '']">
          <i v-if="isDone(index)" class="icon icon-circle-check"></i>
          {{ getTabText(index) }}
        </li>
      </ul>
    </Teleport>

    <div class="b-booking-header-short">
      <span class="b-booking-header-short__icon"></span>
      <span class="b-booking-header-short__current-step">
        {{ step + 1 }}
      </span>
      <span class="b-booking-header-short__steps">/5</span>
      <span class="b-booking-header-short__step-title">
        {{ getTabText(step + 1) }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue'
import { useBookingStore } from '../../store/BookingStore'
import constants from './../../../lib/constants'

defineProps({
  step: { type: Number, required: true, default: 0 },
})
const store = useBookingStore()

const { configuration, dictionary } =
  getCurrentInstance().appContext.config.globalProperties

const showTeleport = configuration.deviceType === constants.deviceType.website

const activeTab = (step) => {
  return store.bookingProgress.wizardStep === step - 1 ? 'is-active' : ''
}

const isDone = (index) => {
  return store.bookingProgress.wizardStep >= index
}

const getTabText = (index) => {
  return dictionary[`wizardStep${index}`]
}
</script>
